import { Link, useLocation } from 'react-router-dom'

export default function SignupConfirmation() {
  const location = useLocation()
  const email = location.state?.email || ''

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-secondary px-4 py-8 font-system light-mode-only">
      <div className="w-full max-w-md animate-fade-in">
        <div className="apple-card animate-slide-in px-6 py-8">
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-status-success/10 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-status-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>

          {/* Success Message */}
          <div className="text-center mb-6">
            <h1 className="apple-text-title mb-2">Check your email</h1>
            <p className="apple-text-body mb-4">
              We've sent a confirmation email to:
            </p>
            {email && (
              <p className="text-sm font-medium text-text-primary mb-4">
                {email}
              </p>
            )}
            <p className="apple-text-body">
              Click the link in the email to verify your account and complete your registration.
            </p>
          </div>

          {/* Instructions */}
          <div className="bg-surface-secondary rounded-lg p-4 mb-6">
            <p className="text-xs text-text-secondary leading-relaxed">
              <strong>Didn't receive the email?</strong> Check your spam folder.
              The email should arrive within a few minutes. If you still don't see it,
              you can try signing up again.
            </p>
          </div>

          {/* Back to Login Link */}
          <div className="text-center">
            <Link
              to="/login"
              className="apple-button-primary w-full"
            >
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
